import React, { Suspense, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoaderContext } from "../../../../../Services/Loader_Provider_Service/LoadingContext";
import { getCourseRating, postSaveCourseRating } from "../../Services/SelfLearning";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { LazyImage } from "../../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Rating } from 'primereact/rating';
import AddCourseToWishlist from "../AddCourseToWishlist/AddCourseToWishlist";
import { TostMsg } from "../../../../../App";
import ERROR_LIST from "../../../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() => import("../../../../../Shared/Sidebar/ComponentLoader"));
function CourseReviews() {
    let userDetails = JSON.parse(localStorage.getItem("User") || '');
    const [courssRate, setCourssRate] = useState([]);
    const { CourseId } = useParams();
    const [ IsLoading, setIsLoading ] = useState(false);
    const [ratevalue, setRateValue] = useState(null);
    const [rateExperience, setRateExperience] = useState('');
    const toster = useContext(TostMsg);
    useEffect(() => {
        GetCourseRating();
    }, [])

    async function GetCourseRating() {
        setIsLoading(true);
        let body = {
            courseId: Number(CourseId),
            userId: 0//userDetails.EmpId
        }
        try {
            let response = await getCourseRating(body);
            setIsLoading(false);
            setCourssRate(response.Data);
        } catch (err) {
            setIsLoading(false);
        }

    }

    async function PostSaveCourseRating() {
        if(ratevalue!=null){
            setIsLoading(true);
            let body = {
                "Id": 0,
                "CourseId": Number(CourseId),
                "Userid": userDetails.EmpId,
                "starRating": ratevalue,
                "comment": rateExperience
            }
            try {
                let response = await postSaveCourseRating(body);
                GetCourseRating();
                setRateValue(null);
                setRateExperience(rate=>(rate,''));
                document.getElementById('give-rating')?.click();
                setIsLoading(false);
            } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
}
        }else{
            alert('Please select rate')
        }
     
    }

    return (
        <div className="position-relation">

            <div id="circular-menu" className="circular-menu">

                <a className="floating-btn" >
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>

                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>

            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-8">
                        <div className="col-xl-12">
                            <div className="card position-rel">
                                <div className="card-body">
                                    <div className="block-header more-padding">
                                        <div className="coursedetail">
                                            <div className="des">
                                                <h4 className="block-heading">{courssRate?.courseName} </h4>
                                                <p className="block-text mb-2">{courssRate?.courseContent}</p>
                                                <div className="showrating-course mb-3"><span>Average Rating - </span><b>{courssRate?.averageRating}</b>
                                                    <ul>
                                                        <li>
                                                            <i className="fa fa-star"></i>
                                                        </li>
                                                        <span>({courssRate?.totalRating}) Students Ratings</span>
                                                    </ul>
                                                </div>
                                                <div className="progress-section" data-aos="fade-left" data-aos-once="true">

                                                    <div className="task-progress">
                                                        <p>5 Star
                                                        </p>
                                                        <progress className="progress progress1" max="5" value={courssRate?.fiveStarRating}></progress>
                                                    </div>
                                                    <div className="task-progress">
                                                        <p>4 star
                                                        </p>
                                                        <progress className="progress progress1" max="5" value={courssRate?.fourStarRating}></progress>
                                                    </div>
                                                    <div className="task-progress">
                                                        <p>3 Star
                                                        </p>
                                                        <progress className="progress progress1" max="5" value={courssRate?.threeStarRating}></progress>
                                                    </div>
                                                    <div className="task-progress">
                                                        <p>2 Star
                                                        </p>
                                                        <progress className="progress progress1" max="5" value={courssRate?.twoStarRating}></progress>
                                                    </div>
                                                    <div className="task-progress">
                                                        <p>1 Star
                                                        </p>
                                                        <progress className="progress progress1" max="5" value={courssRate?.oneStarRating}></progress>
                                                    </div>
                                                </div>
                                                <p className="give-rating" data-bs-toggle="modal" data-bs-target="#give-rating">How was your experience?</p>
                                            </div>
                                            <Link to="/CourseDetail" className="add-more">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                    fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
                                                  16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
                                                  07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
                                                  .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body ">
                                    <div className="more-jobdetail p-3">
                                        <div id="testimonials">                                            
                                            {courssRate && courssRate?.courseRatings?.length != 0
                                                ?
                                                courssRate?.courseRatings?.map((courssrate, index) => (
                                                    <div className="testimonial-box-container">
                                                        <div className="testimonial-box">
                                                            <div>
                                                                <div className="box-top">
                                                                    <div className="profile">
                                                                        <div className="profile-img">
                                                                            <LazyImage src={courssrate?.ProfileImage} />
                                                                        </div>
                                                                        <div className="name-user">
                                                                            <strong>{courssrate?.EmployeeName}</strong>
                                                                            <span>{courssrate?.Designation}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="reviews">
                                                                        <Rating value={courssrate?.starRating} disabled cancel={false} style={{ color: '#f9d71c!important' }} />
                                                                    </div>
                                                                </div>
                                                                <div className="client-comment">
                                                                    <p>{courssrate?.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )) : 'No Data Found.'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="col-xl-4">
                    <AddCourseToWishlist/>
                    </div>
                </div>

            </div>
            <div className="modal fade" id="give-rating">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <img src="/images/org-img/learn/rate.png" />
                        <div className="modal-header p-0">
                            <h5 className="modal-title m-auto">How would you rate your course experience?</h5>
                        </div>
                        <div className="modal-body text-center">
                            <Rating value={ratevalue} onChange={(e) => setRateValue(e.value)} cancel={false} />
                            {/* <ul className="rate">
                                <li><i className="fa fa-star"></i></li>
                                <li><i className="fa fa-star"></i></li>
                                <li><i className="fa fa-star"></i></li>
                                <li><i className="fa fa-star-o"></i></li>
                                <li><i className="fa fa-star-o"></i></li>
                            </ul> */}
                            <form>
                                <div className="form-group text-left">
                                    <textarea rows="6" cols="1" onChange={(e) => setRateExperience(e.target.value)} className="form-control" placeholder="I would like to say that..."></textarea></div>
                            </form>
                        </div>
                        <div className="modal-footer m-auto">
                            <button className="savebtn-click" onClick={()=>PostSaveCourseRating()}>Submit</button>
                            {/* <i onClick={()=>PostSaveCourseRating()} className="fa fa-angle-right" aria-hidden="true"></i> */}
                        </div>
                    </div>
                </div>
            </div>

             {IsLoading ?<Suspense >
                <ComponentLoader />
            </Suspense> : ''} 
        </div>
    )
}
export default CourseReviews;